<div class="term">
  <div class="term-container">
  </div>
  <div class="term-header">
    <h1 class="term-header--title">{{'TERMS_OF_USE_FOOT' | translate}}</h1>
  </div>
  <div class="term-rules">
    <p class="term-subtitle">Datos de la empresa que presta el servicio</p>
    <p>
      Los presentes términos y condiciones de uso regulan los servicios prestados por City Expert S.L. (en adelante,
      City
      Expert) en el presente Sitio Web (en adelante, Sitio Web). Los datos registrales de City Expert son:
    </p>
    <p>Titular: City Expert S.L.</p>
    <p>CIF: B91375238</p>
    <p>Domicilio: Calle Jaén 2, 1º planta, 41001, Sevilla</p>
    <p>Email de contacto: <a>reservas@cityexpert.travel</a></p>
    <p>Teléfono: 900 92 00 92</p>

    <p class="term-subtitle">Aceptación de las condiciones de uso y acceso al sitio web</p>
    <p> Al contratar los servicios a través de este Sitio Web, el usuario acepta los presentes
      Términos y Condiciones de Uso. Estos términos definen los derechos y obligaciones
      de City Expert y de los Usuarios en este Sitio Web.</p>
    <p> Estos Términos y Condiciones de Uso son los únicos aplicables en los servicios y
      actividades ofrecidas en el Sitio Web. Estos Términos sustituyen cualesquiera otras
      condiciones externas, a excepción de un acuerdo previo por escrito entre City Expert y
      el Usuario.</p>
    <p> La contratación de cualquiera de los servicios ofrecidos en el Sitio Web requerirá la
      aceptación previa del Usuario de los presentes Términos y Condiciones de Uso antes
      de proceder al pago de la actividad.</p>

    <p class="term-subtitle">Objeto del sitio web</p>

    <p> City Expert ofrece en el presente Sitio Web servicios de reservas de actividades,
      visitas guiadas, excursiones y venta de tickets de atracciones en diferentes destinos
      de España.</p>
    <p> Las actividades publicadas en el Sitio Web están ofrecidas tanto por City Expert como
      por otras terceras empresas colaboradoras (en adelante, el/los Proveedor/es). Por lo
      tanto, los servicios de actividades, visitas guiadas, excursiones y tickets de
      atracciones ofrecidos en el Sitio Web están realizados directamente por los
      proveedores en el destino.</p>
    <p> Además de reserva de actividades, City Expert ofrece en este Sitio Web información
      adicional sobre sus destinos y una agenda cultural de eventos celebrados en los
      mismos.</p>
    <p class="term-subtitle">Reservas en City Expert en el sitio web</p>
    <p>Datos de usuarios</p>
    <p> Para realizar reservas en el Sitio Web, el Usuario no necesitan realizar un registro
      previo. Por otra parte, el Usuario deberá proporcionar sus datos personales para la
      confirmación de la reserva de actividades. Los datos personales incluirán nombre,
      apellidos, documento de identidad o pasaporte (en algunos casos), e-mail y teléfono
      de contacto.</p>
    <p> El Usuario es responsable de la veracidad y exactitud de los datos personales que
      proporciona en el Sitio Web, siendo el único responsable en el caso de que hubiera
      errores en la reserva por la información ofrecida.</p>
    <p> En caso de haber ofrecido información errónea en el momento de la reserva de la
      actividad, el Usuario deberá contactar de forma inmediata con City Expert enviando un
      correo electrónico a <a>reservas@cityexpert.travel</a>. A través de este correo electrónico el
      Usuario podrá comunicar cualquier error o uso fraudulento de sus datos para que City
      Expert puede proceder a la modificación o cancelación de la reserva correspondiente,
      siempre y cuando no se haya realizado el servicio.</p>
    <p> Mediante la aceptación de los Términos y Condiciones de Uso, el Usuario manifiesta
      ser mayor de 18 años, siendo el Usuario responsable de los datos proporcionados en
      caso de no ser así. City Expert se reserva el derecho de cancelar cualquier reserva
      que indique que el usuario es menor de edad.</p>
    <p> City Expert se exime de cualquier tipo de responsabilidad en el caso de que el Usuario
      incumpla alguno de los párrafos anteriores.</p>
    <p class="term-subtitle">Condiciones específicas de reserva de actividades</p>
    <p>Cada una de las actividades y servicios disponibles para reservar en el Sitio Web
      están sujetas a condiciones específicas aplicadas a la actividad en concreto e
      indicadas por el Proveedor correspondiente. El Usuario encontrará las condiciones
      específicas de cada actividad dentro de la página de cada producto, en la sección
      “Qué debes saber antes de partir”. El Usuario podrá encontrar aquí toda la información
      útil, importante y necesaria de la actividad.</p>

    <p>Condiciones generales</p>
    <p> La reserva de actividades en el Sitio Web están sujetas a las siguientes condiciones
      generales:</p>
    <p>-Las fechas y horarios disponibles estarán publicados en el Sitio Web de acuerdo a la
      información proporcionada por el Proveedor. Esta disponibilidad no podrá modificarse.</p>
    <p>-En caso de querer realizar una modificación del servicio contratado, el Usuario podrá
      contactar con la Central de Información y Reservas de City Expert a través del correo
      electrónico <a>reservas@cityexpert.travel</a> para comprobar si el cambio solicitado es factible.
      Se recuerda que los cambios vendrán determinados por el Proveedor y está sujeto a
      disponibilidad de la actividad. En el caso de la venta de tickets y entradas a una
      atracción (sin visita guiada), el horario vendrá determinado por las horas de apertura
      del monumento/museo/atracción en concreto.</p>
    <p>-En el caso de algunas actividades, excursiones o visitas guiadas concretas, se
      requerirá un tiempo de antelación mínimo para la reserva, establecido por el
      Proveedor. Esta información irá reflejada en la sección “Antes de llegar” de cada
      página de producto.</p>
    <p> -Para las peticiones de servicios privados y personalizados, contacte directamente con
      nuestra Central de Información y Reservas de City Expert a través del correo
      electrónico <a>reservas@cityexpert.travel</a>.</p>
    <p>Condiciones de específicas (actividades, visitas guiadas y excursiones)</p>
    <p> Los datos específicos de cada actividad, tales como fecha, horarios, puntos de
      encuentro, duración, idiomas disponibles y dirección de la atracción se encontrarán en
      la sección “Antes de llegar” dentro de cada producto. Todos estos datos se publican de
      acuerdo a la información proporcionada por el Proveedor.</p>
    <p> Una vez realizada la reserva, el Usuario recibirá un mail de confirmación con todos los
      datos relevantes del producto contratado. En ese mail de confirmación se adjuntará un
      bono con todos los datos de la reserva. Ese bono será el justificante de la reserva, que
      deberá ser entregado para realizar la actividad contratada. El Proveedor requerirá el
      bono de confirmación para poder disfrutar del servicio.</p>
    <p> El Usuario deberá acudir al punto de encuentro y hora indicada para la realización de
      la actividad. Se ruega puntualidad para cumplir con el desarrollo del servicio. City
      Expert no se hace responsable de las circunstancias ajenas que impidan acudir al
      servicio contratado en la fecha y hora indicadas. En caso de duda con alguno de los
      detalles de la reserva, el Usuario podrá contactar con la Central de Información y
      Reservas de City Expert, por teléfono (+34 900 92 00 92) o por correo electrónico
      (reservas@cityexpert.travel).</p>
    <p> Condiciones de pago en City Expert</p>
    <p> El contrato de los servicios ofrecidos en el Sitio Web se entiende formalizado una vez
      que el Usuario acepta los Términos y Condiciones de Uso y completa el proceso de
      reserva de la actividad, seleccionando los datos concretos de la misma e indicando
      sus datos personales.</p>
    <p> Los servicios contratados en el Sitio Web son cobrados en su totalidad tras la
      confirmación de la reserva. En algunos casos, por indicaciones del Proveedor, el
      Usuario podrá pagar una parte del servicio contratado, abonando el resto en el
      momento de realizar el servicio en destino. Esta condición especial viene determinada
      por el Proveedor y será indicado en la página del producto y su ficha informativa.</p>
    <p>Formas de pago y tipos de divisa</p>
    <p> Las actividades ofrecidas en el Sitio Web podrá pagarse mediante tarjeta de crédito o
      débito (Visa, Mastercard), Paypal, Giropay y Sofort.</p>
    <p>Las tarifas de los servicios estarán indicadas en Euros (€).</p>
    <p> Asimismo, la cantidad abonada se reflejará en el mail de confirmación y el bono
      adjunto de la reserva que recibirá el Usuario una vez realizada la compra.</p>
    <p> No se aplicarán descuentos a menos que el Usuario disponga de un código específico
      para su aplicación en el momento del pago.</p>
    <p> Todos los pagos online realizados en esta página son seguros 100%, evitando fraudes
      o transacciones no autorizadas. En el caso de que Usuario identifique algún cobro
      indebido o cargo adicional en la tarjeta utilizada para la reserva, deberá contactar de
      forma inmediata con la Central de Información y Reservas de City Expert, ya sea por
      teléfono (+34 900 92 00 92) o por correo electrónico (reservas@cityexpert.travel).</p>
    <p class="term-subtitle">Política de cancelación</p>
    <p>La Política de cancelación del servicio estará determinada por el Proveedor. El
      Usuario podrá consultar las condiciones de cancelación en la sección “Política de
      cancelación” que se encuentra en cada página de cada producto.</p>
    <p>El Proveedor del servicio o actividad será el responsable de la Política de cancelación,
      indicando en la misma las condiciones para cancelar, plazos y posibles penalizaciones
      derivadas de la cancelación (si las hubiera).</p>
    <p> Mediante la aceptación de estos Términos y Condiciones de Uso, el Usuario acepta
      las condiciones generales y específicas de cada producto, así como la política de
      cancelación indicada por el Proveedor del servicio. City Expert no se hace
      responsable de las condiciones específicas indicadas por cada Proveedor externo.</p>
    <p class="term-subtitle">Conducta en el sitio web</p>
    <p>El Usuario se compromete a:</p>
    <p>Hacer un uso adecuado y lícito del Sitio Web así como de los contenidos y servicios,
      de conformidad con: (i) la legislación aplicable en cada momento; (ii) las Condiciones
      Generales de Uso del Sitio Web; (iii) la moral y buenas costumbres generalmente
      aceptadas y (iv) el orden público.
      Proveerse de todos los medios y requerimientos técnicos que se precisen para
      acceder al Sitio Web.</p>
    <p> Facilitar información veraz al cumplimentar con sus datos de carácter personal los
      formularios contenidos en el Sitio Web y a mantenerlos actualizados en todo momento
      de forma que responda, en cada momento, a la situación real del Usuario. El Usuario
      será el único responsable de las manifestaciones falsas o inexactas que realice y de
      los perjuicios que cause a City Expert o a terceros por la información que facilite.</p>
    <p>No obstante lo establecido en el apartado anterior el Usuario deberá asimismo abstenerse de:</p>
    <p>a) Hacer un uso no autorizado o fraudulento del Sitio Web y/o de los contenidos con fines o efectos ilícitos,
      prohibidos en las presentes Condiciones Generales de Uso, lesivos de los derechos e intereses de terceros, o que
      de
      cualquier forma puedan dañar, inutilizar, sobrecargar, deteriorar o impedir la normal utilización de los
      servicios
      o los documentos, archivos y toda clase de contenidos almacenados en cualquier equipo informático.</p>
    <p>b) Acceder o intentar acceder a recursos o áreas restringidas del Sitio Web, sin cumplir las condiciones
      exigidas
      para dicho acceso.</p>
    <p>c) Provocar daños en los sistemas físicos o lógicos del Sitio Web, de sus proveedores o de terceros.</p>
    <p>d) Introducir o difundir en la red virus informáticos o cualesquiera otros sistemas físicos o lógicos que sean
      susceptibles de provocar daños en los sistemas físicos o lógicos de la EMPRESA, de sus proveedores o de terceros.</p>
    <p>e) Intentar acceder, utilizar y/o manipular los datos de City Expert, terceros proveedores y otros Usuarios.</p>
    <p>f) Reproducir o copiar, distribuir, permitir el acceso del público a través de cualquier modalidad de
      comunicación pública, transformar o modificar los contenidos, a menos que se cuente con la autorización del
      titular de los
      correspondientes derechos o ello resulte legalmente permitido.</p>
    <p>g) Suprimir, ocultar o manipular las notas sobre derechos de propiedad intelectual o industrial y demás datos
      identificativos de los derechos de City Expert o de terceros incorporados a los contenidos, así como los
      dispositivos técnicos de protección o cualesquiera mecanismos de información que puedan insertarse en los
      contenidos.</p>
    <p>h) Obtener e intentar obtener los contenidos empleando para ello medios o procedimientos distintos de los que,
      según los casos, se hayan puesto a su disposición a este efecto o se hayan indicado expresamente en las páginas
      web donde se encuentren los contenidos o, en general, de los que se empleen habitualmente en Internet por no
      entrañar
      un riesgo de daño o inutilización del sitio web y/o de los contenidos.</p>
    <p>i) En particular, y a título meramente indicativo y no exhaustivo, el Usuario se compromete a no transmitir,
      difundir o poner a disposición de terceros informaciones, datos, contenidos, mensajes, gráficos, dibujos,
      archivos de sonido y/o imagen, fotografías, grabaciones, software y, en general, cualquier clase de material que:</p>
    <p>(i) De cualquier forma sea contrario, menosprecie o atente contra los derechos fundamentales y las libertades
      públicas reconocidas constitucionalmente, en los Tratados Internacionales y en el resto de la legislación
      vigente.</p>
    <p>(ii) Induzca, incite o promueva actuaciones delictivas, denigratorias, difamatorias, violentas o, en general,
      contrarias a la ley, a la moral, a las buenas costumbres generalmente aceptadas o al orden público.</p>
    <p>(iii) Induzca, incite o promueva actuaciones, actitudes o pensamientos discriminatorios por razón de sexo, raza,
      religión, creencias, edad o condición.</p>
    <p>(iv) Incorpore, ponga a disposición o permita acceder a productos, elementos, mensajes y/o servicios delictivos,
      violentos, ofensivos, nocivos, degradantes o, en general, contrarios a la ley, a la moral y a las buenas
      costumbres generalmente aceptadas o al orden público.</p>
    <p>(v) Induzca o pueda inducir a un estado inaceptable de ansiedad o temor.</p>
    <p>(vi) Induzca o incite a involucrarse en prácticas peligrosas, de riesgo o nocivas para la salud y el equilibrio
      psíquico.</p>
    <p>(vii) Se encuentra protegido por la legislación en materia de protección intelectual o industrial perteneciente
      a City Expert o a terceros sin que haya sido autorizado el uso que se pretenda realizar.</p>
    <p>(viii) Sea contrario al honor, a la intimidad personal y familiar o a la propia imagen de las personas.</p>
    <p>(ix) Constituya cualquier tipo de publicidad.</p>
    <p>(x) Incluya cualquier tipo de virus o programa que impida el normal funcionamiento del Sitio Web.</p>
    <p>Si para acceder a algunos de los servicios y/o contenidos del Sitio Web, se le
      proporcionará una contraseña, se obliga a usarla de manera diligente, manteniéndola
      en todo momento en secreto. En consecuencia, será responsable de su adecuada
      custodia y confidencialidad, comprometiéndose a no cederla a terceros, de manera
      temporal o permanente, ni a permitir el acceso a los mencionados servicios y/o
      contenidos por parte de personas ajenas. Igualmente, se obliga a notificar a City
      Expert cualquier hecho que pueda suponer un uso indebido de su contraseña, como, a
      título enunciativo, su robo, extravío o el acceso no autorizado, con el fin de proceder a
      su inmediata cancelación. En consecuencia, mientras no efectúe la notificación
      anterior, City Expert quedará eximida de cualquier responsabilidad que pudiera
      derivarse del uso indebido de su contraseña, siendo de su responsabilidad cualquier
      utilización ilícita de los contenidos y/o servicios del Sitio Web por cualquier tercero
      ilegítimo.</p>
    <p>Si de manera negligente o dolosa incumpliera cualquiera de las obligaciones
      establecidas en las presentes Condiciones Generales de Uso, responderá por todos
      los daños y perjuicios que de dicho incumplimiento pudieran derivarse para City
      Expert.</p>
    <p class="term-subtitle">Exclusión de responsabilidad</p>
    <p>City Expert no se hace responsable de las siguientes circunstancias referentes a las
      actividades:</p>
    <p>-De los retrasos o confusiones del Usuario para acudir a la actividad en la fecha, hora
      y punto de encuentro indicados.</p>
    <p>-De las cancelaciones solicitadas fuera de plazo o para actividades que no contemplan
      la cancelación. City Expert se acogerá a la Política de cancelación del Proveedor del
      servicio para decidir si procede o no la cancelación y devolución monetaria.</p>
    <p>-De los daños, pérdidas y/o robos producidos que afecten al Usuario y sus bienes
      durante la realización de las actividades contratadas.</p>
    <p> -De las lesiones, daños y accidentes que afecten al Usuario durante el desarrollo de
      cualquiera de las actividades contratadas. Tampoco de los daños anteriores que
      pudiera sufrir, impidiendo la realización de la actividad.</p>
    <p>-De las consecuencias derivadas de no presentar el bono de confirmación que se
      envía al Usuario en el momento de la actividad. El Proveedor podrá negar la
      realización de la actividad a toda aquella persona que no presente el bono
      correspondiente de City Expert.</p>
    <p>-Del no cumplimiento de las expectativas sobre el servicio contratado. City Expert
      ofrece servicios y actividades de calidad contrastada. El Proveedor será el último
      responsable en caso de que el Usuario no quede satisfecho con la calidad.</p>
    <p>-De las condiciones meteorológicas que se den durante el desarrollo de cualquiera de
      las actividades. City Expert sólo se hará responsable en el caso de que las
      condiciones meteorológicas impidan la realización de la actividad y reciba
      confirmación por parte del Proveedor.</p>
    <p>-De la pérdida de reservas, medios de transporte u otras actividades como
      consecuencia del desarrollo de la actividad contratada en el Sitio Web, incluso aunque
      sea otra actividad reservada en este mismo Sitio Web. El Usuario debe confirmar las
      fechas, horas y duración de cada una de las actividades reservadas (ya sea con City
      Expert u otros), siendo el único responsable y confirmando que puede cumplir con la
      realización de todas ellas.</p>
    <p>-De los fallos técnicos, bloqueos o suspensión del Sitio Web provocados por terceros
      que impidan la realización de reservas y el correcto funcionamiento de la página.</p>
    <p class="term-subtitle">Propiedad Industrial e Intelectual</p>
    <p>La Web y todos sus contenidos, características y funciones (incluidos toda la información, software, texto,
      visualizaciones, imágenes, vídeo y audio, y el diseño, selección y disposición de los mismos, etc.) son propiedad
      de la empresa City Expert, y están protegidos por las leyes de derechos de marca, diseño, patente, modelo de
      utilidad, secreto comercial, derecho de autor y otros derechos relativos a la propiedad industrial, intelectual o
      de propiedad.</p>
    <p>Sólo puede utilizar la Web para las finalidades incluidas en estos Términos y
      Condiciones de Uso. Puede hacer copias de la Web (o partes de la misma) para su
      uso personal.</p>
    <p class="term-subtitle">Modificaciones de los Términos y Condiciones de Uso
    </p>
    <p>City Expert se reserva el derecho a actualizar y modificar los Términos y Condiciones
      de Uso cuando lo considere necesario, con el fin de disponer de información
      actualizada para el usuario. Las modificaciones entrarán en vigor a partir de su
      publicación en el Sitio Web.</p>
    <p class="term-subtitle">Cláusula de salvaguarda</p>
    <p>Todas las cláusulas de estos Términos y Condiciones de Uso deben ser interpretadas de forma independiente y
      autónoma, no viéndose afectadas el resto de estipulaciones en caso de que una de ellas haya sido declarada nula
      por
      sentencia judicial o resolución arbitral firme. Se sustituirá la cláusula o cláusulas afectadas por otra u otras
      que preserven los efectos perseguidos por los presentes Términos y Condiciones de Uso.</p>
    <p class="term-subtitle">Legislación aplicable</p>
    <p>Los presentes Términos y Condiciones de Uso están sometidos a la legislación española. Para la resolución de
      cualquier controversia que pudiera surgir, las partes, con renuncia expresa a cualquier otro fuero, se someten a
      los Juzgados y Tribunales de Sevilla.</p>
  </div>
</div>